import { createSlice } from '@reduxjs/toolkit'

export const progressSlice = createSlice({
  name: 'progress',
  initialState: {
    jobId: null,
    progress: 0,
    isProcessComplete: false,
  },
  reducers: {
    setJobId: (state, action) => {
      state.jobId = action.payload
    },
    setProgress: (state, action) => {
      state.progress = action.payload
    },
    setIsProcessComplete: (state, action) => {
      state.isProcessComplete = action.payload
    },
    resetProgress: (state) => {
      state.jobId = null
      state.progress = 0
    },
  }
})

export const { setMetroList } = progressSlice.actions
export default progressSlice.reducer